import React from 'react';
import ProductForm from './ProductForm';
import {
  AuthProvider,
  DialogProvider,
  ProductsProvider,
  ValuesProvider
} from 'contexts';

export default () => {
  return (
    <AuthProvider>
      <ProductsProvider>
        <DialogProvider>
          <ValuesProvider>
            <ProductForm/>
          </ValuesProvider>
        </DialogProvider>
      </ProductsProvider>
    </AuthProvider>
  );
}
